import { getContext } from '@fiverr-private/fiverr_context';

const PLATFORMS = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};

/**
 * Builds a base grafana event constructor
 *
 * @param {string} type - The big query event type
 * @returns {Function} contextualized grafana event
 */
export const buildGrafanaEvent = (type) => () => {
    const platform = calculatePlatform();

    return `${platform}.${type}`;
};

/**
 * Calculates reported platform according to the user agent
 *
 * @returns {string} reported platform
 */
const calculatePlatform = () => {
    const { isTouch } = getContext();

    return isTouch ? PLATFORMS.MOBILE : PLATFORMS.DESKTOP;
};
